import { FilmProject } from '../types';

export const filmProjects: FilmProject[] = [
  {
    id: 'silicon-soul',
    title: 'Chronicles of the Silicon Soul',
    category: 'AI Sci-Fi Movie',
    logline: 'When an experimental consciousness awakens in deep orbital silence, humanity must confront its ultimate creation.',
    description: 'A groundbreaking cinematic short film generated using cutting-edge multi-modal AI video pipelines, neural voice synthesis, and generative orchestral scoring by AtomixMusics.',
    thumbnail: '/images/brand/film-silicon-soul.jpg',
    youtubeUrl: 'https://youtube.com/@atomixchannel',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2026-06-15',
    tags: ['Sci-Fi', 'AI Cinema', 'Cyberpunk', 'Space Odyssey'],
    featured: true
  },
  {
    id: 'neon-shadows-atlanta',
    title: 'Neon Shadows: Atlanta 2088',
    category: 'AI Drama Series',
    logline: 'In a futuristic Atlanta sprawling with cyber-synths and corporate megastructures, two rogue engineers seek the truth.',
    description: 'An episodic AI drama mini-series mixing atmospheric neo-noir cinematography, dramatic AI voice acting, and localized futuristic worldbuilding.',
    thumbnail: '/images/brand/film-neon-shadows.jpg',
    youtubeUrl: 'https://youtube.com/@atomixchannel',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2026-03-20',
    tags: ['Drama', 'Episodic Series', 'Neo-Noir', 'Atlanta'],
    featured: true
  },
  {
    id: 'fractal-dreams-shorts',
    title: 'Fractal Dreams: Micro Stories',
    category: 'Viral Shorts',
    logline: 'Bite-sized mind-bending sci-fi vignettes and surreal visual poetry engineered for modern short-form feeds.',
    description: 'Fast-paced, hyper-visual AI shorts tailored for YouTube Shorts & TikTok, generating thousands of shares with hypnotic audio and fractal visual morphing.',
    thumbnail: '/images/brand/film-fractal-dreams.jpg',
    youtubeUrl: 'https://youtube.com/@atomixchannel',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-11-10',
    tags: ['Shorts', 'TikTok', 'Viral', 'Visual Effects'],
    featured: false
  },
  {
    id: 'cyber-protocol-short',
    title: 'Cyber Protocol: Zero Meridian',
    category: 'Cinematic Short',
    logline: 'A lone cybernetic guardian protects the core server bank during the great blackout.',
    description: 'An adrenaline-infused action cinematic featuring choreographed AI combat simulations, synchronized dynamic sound design, and photorealistic particle renders.',
    thumbnail: '/images/brand/atomix-film-banner.jpg',
    youtubeUrl: 'https://youtube.com/@atomixchannel',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-08-14',
    tags: ['Action', 'CGI Simulation', 'Neural Audio'],
    featured: false
  }
];
